import TextEditorCustomize from '@/components/TextEditorCustomize'
import { Ticket } from '@/modules/Ticket/types/response'
import { formatFromUTC } from '@/utils/function'
import { useTranslation } from 'react-i18next'
import { Alert, Typogaphy } from 'vnetwork-ui'
interface TicketMajorProps {
    ticket?: Ticket
}
const TicketMajor: React.FC<TicketMajorProps> = ({ ticket }) => {
    const { t } = useTranslation()
    return (
        <div className="">
            <div className="bg-[#1A237E14] p-4 rounded-md">
                <Alert size="small" variant="info" className="mb-4">
                    {t('ticket-notification-text-1')} (
                    <strong>Major Incident</strong>){' '}
                    {t('ticket-notification-text-2')}
                </Alert>
                <Typogaphy size="small" className="gap-4 space-y-2">
                    <li>
                        <strong>{t('ticket-notification-service')}</strong>{' '}
                        {ticket?.product_group_name}
                    </li>
                    <li>
                        <strong>{t('ticket-notification-time')}</strong>{' '}
                        {formatFromUTC(ticket?.ticket_requested_at || '')}
                    </li>
                    <TextEditorCustomize
                        value={{
                            text: ticket?.ticket_content || '',
                            attachments: [] as any[],
                        }}
                        disabled={true}
                        className="mt-4"
                    />
                </Typogaphy>
                <Typogaphy
                    size="medium"
                    className="my-2 text-[16px] font-semibold"
                >
                    {t('ticket-notification-text-3')}
                </Typogaphy>
                <Typogaphy size="small" className="text-primary">
                    <em className="italic">
                        {t('ticket-notification-text-4')}
                    </em>
                </Typogaphy>
            </div>
        </div>
    )
}

export default TicketMajor
